// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'arrow-down';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M9 3v13m6-6.067L9 16 3 9.933'
  />
);

export const viewBox = '0 0 18 18';
